import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MobXProviderContext, useObserver } from 'mobx-react';
import { CommonText } from '@lib/components';
import { format } from 'date-fns'
import { MobileBookings } from '../mobileBookings';
import { DesktopBookings } from './desktopBookings';

export const BookingsV2 = () => {
    return useObserver(() => {
        const { store } = React.useContext(MobXProviderContext);
        const { mobileSettingsOpen } = store;

        useEffect(() => {
            if("bookingSetting" in localStorage){
                let rawData = localStorage.getItem('bookingSetting');
                let savedSetting = JSON.parse(rawData || '') ;
                if(savedSetting && savedSetting?.rid === store.restaurant!._id){
                    const newDisplaySetting = { ...store.bookingSettings, displaySetting: savedSetting.displaySetting }
                    store.setBookingSetting(newDisplaySetting)
                }
            }
            handleGetSettingData();
            handleGetBookingData();
            handleGetUnconfirmCount();
        }, [])

        const handleGetSettingData = async () => {
            const settingResponse = await store.api.get_bookings_setting(store.restaurant!._id);
            if (settingResponse.outcome !== 0)
                throw new Error(settingResponse.message);
            store.setBookingSetting(settingResponse.data);
            localStorage.setItem('bookingSetting', JSON.stringify({ rid: store.restaurant!._id, displaySetting: settingResponse.data.displaySetting}))
        }

        const handleGetBookingData = async () => {
            const response = await store.api.get_bookings(store.restaurant!._id);

            if (response.outcome !== 0)
                throw new Error(response.message);
            store.updateBookings({
                items: response.data,
                page: 1
            });
            store.updateFilteredBookings({
                filterType: {
                    sortOrder: 'asc', sortBy: 'status', filterStatus: 'all'
                }
            })
        }
     
        const handleGetUnconfirmCount = async () => {
            const response = await store.api.get_count_unconfirmed_booking(store.restaurant!._id);
            store.setUnconfirmBookingCount(response.data)
        }

        const BookingWrapper = styled.div`
            .booking-mobile {
                display: none;
            }
            @media (max-width: 767px) {
                .booking-mobile {
                    display: block;
                }
                .booking-desktop {
                    display: none;
                }
            }
        `;

        return (
            <>
                
                    <BookingWrapper>
                        <div className="booking-desktop">
                            <DesktopBookings />
                        </div>
                        <div className="booking-mobile">
                            <MobileBookings />
                        </div>
                    </BookingWrapper>
            </>
        );
    })

};
